import { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import Loader from '../Layout/Loader';
import { ClearSession, formatDate, GetDate, OpenBase64Pdf, ReverseFormatDate, setFocus, setTitle } from '../Common/Common';
import { Cookies } from 'react-cookie';
import { AlertBox, AutoCompleteBox, DateBox } from '../Common/Input';
import { useRef } from 'react';
import { getCommonData } from '../Common/CommanServices';
import { post } from '../Common/service';
import { API_SERVER } from '../../EnvConfig/env_config';
import Swal from 'sweetalert2';
import { useNavigate } from "react-router-dom";

const PaymentReceipt = ({ open, setOpen }) => {
    const cookies = new Cookies();
    const inputrefs = useRef([]);
    const Token = cookies.get('token')
    const navigate = useNavigate();
    const LoginUserCode = cookies.get('loginUserCode').toString();
    const IsBackOfficeUser = cookies.get('IsBackOfficeUser');
    const [isLoading, setIsLoading] = useState(false);
    const [SessionClear, SetSessionClear] = useState(false);
    const [CustomerData, setCustomerData] = useState([]);
    const [MenuText, setMenuText] = useState("Payment Receipt");
    const [SaveData, setSaveData] = useState({
        ReceiptNo: "Syatem-Generated",
        Customer: "",
        TotalAmount: "0",
        ReceivedMode: "",
        AdvanceAmount: "0",
        RefNo: "",
        ReceiptDate: GetDate(0),
        ChequeDate: GetDate(0),
        Remarks: "",
        InvoiceList: [],
        IsActive:"true",
    });
  
    const [AmountBreakup, setAmountBreakup] = useState({
        TotalAmount: 0.00,
        AdjustedAmount: 0.00,
        RemainingAmount: 0.00
    });

    const HandleChange = (prop, value) => {
        setSaveData(SaveData => ({ ...SaveData, [prop]: value }));
    }

    const getCustomer = () => {
        setCustomerData([])
        let temp = {
            Type: "GetCustomer",
            Prefix: "",
            ContextKey: "",
            ContextKey2: ""
        }
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token: Token, LoginUserCode: loginCodeString
        }
        getCommonData({ ...data, ...temp }, (res) => {
            if (res && res.status === "SUCCESS") {
                let CustomerDatalist = res.autoCompleteData || [];
                setCustomerData(CustomerDatalist);
            } else {
                setCustomerData([]);
            }
        });
    }

    let CustomerArr = []
    
    for (let i = 0; i < CustomerData.length; i++) {
        let mydata = CustomerData[i]?.values
        CustomerArr.push(mydata)
    };
    const GetPendingBillData = (Customer) => {
        setSaveData({
            ...SaveData,
            Customer: Customer,
            InvoiceList: []
        });

        const GetAdvanceAMount = 0;
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token, LoginUserCode: loginCodeString, Customer: Customer
        }
        post(`${API_SERVER}/api/Operation/GetPendingBill`, { ...data }, (res) => {
            if (res.Status === 'SUCCESS') {
                let returnedItemDetails = [];

                res.Data.forEach((item, index) => {
                    let Item = {};
                    Item.IsItemEnable = false
                    Item.InvoiceNo = item.InvoiceNo;
                    Item.InvoiceDate = item.InvoiceDate;
                    Item.InvoiceAmount = item.InvoiceAmount;
                    Item.OutstandingAmount = item.OutstandingAmount;
                    Item.ReceivedAmount = "0.00";
                    Item.WareHouse = item.WareHouse;
                    Item.SalesPerson = item.SalesPerson;
                    returnedItemDetails.push(Item);
                });
                setSaveData({
                    ...SaveData,
                    Customer: Customer,
                    InvoiceList: returnedItemDetails,
                    AdvanceAmount: res?.Data?.[0]?.AdvanceAmount,
                    IsActive: res?.Data?.[0]?.AdvanceAmount ? false : SaveData.IsActive
                });
            }
            else if (res.Message === "EXPIRED") {
                navigate('/Login')
            }
            if (res.Status === "ERROR") {
                AlertBox(res.Status, res.Message, res.focus);
            }
        })
    }

    const handleSubmitData = () => {
        Swal.fire({
            title: "Do you want to Save Payment Receipt ?",
            showDenyButton: true,
            showCancelButton: false,
            icon: "info",
            confirmButtonText: "Yes",
            denyButtonText: "No"
        }).then((result) => {
            if (result.isConfirmed) {
                const loginUserCode = String(LoginUserCode)
                setIsLoading(true)
                let data = {
                    ...SaveData, Token, LoginUserCode: loginUserCode, Source: 'WEB'
                }
                post(`${API_SERVER}/api/Operation/SaveReceiptEntry`, { ...data }, (res) => {
                    if (res.status === 'SUCCESS') {
                        AlertBox(res.status, res.message, res.focus);
                        handlePrintData(res.paymentReceiptNo)
                        handleClearData();
                    }
                    else if (res.message === "EXPIRED") {
                        navigate('/Login')
                    }
                    else if (res.message !== "") {
                        AlertBox("error", res.message, res.focus);
                        setIsLoading(false);
                    }
                    setFocus(res.focus);
                })
            }

        });
    }
    const handlePrintData = (PaymentReceiptNo) => {
        const loginCodeString = String(LoginUserCode);
        const data = {
            PaymentReceiptNo: PaymentReceiptNo,
            Source: "Report",
            Token,
            LoginUserCode: loginCodeString
        };
        setIsLoading(true)
        post(`${API_SERVER}/api/Print/PaymentReceiptPrint`, { ...data }, (res) => {
            if (res.message === 'EXPIRED') {
                navigate('/Login')
            }
            else if (res.status === 'SUCCESS') {
                console.log(res, "resresres")
                OpenBase64Pdf(res.documentPdfBase64, 'PaymentReceiptPrint_' + PaymentReceiptNo, '_blank');
            }
            if (res.status === 'ERROR' || res.message !== '') {
                AlertBox(res.status, res.message, res.focus);
            }
            if (res.focus !== "") {
                setFocus(res.focus);
            }
            setIsLoading(false)
        });
    }

    const handleClearData = () => {
        setSaveData({
            ...SaveData,
            ReceiptNo: "System-Generated",
            Customer: "",
            TotalAmount: "0",
            ReceivedMode: "",
            RefNo: "",
            ReceiptDate: GetDate(0),
            ChequeDate: GetDate(0),
            Remarks: "",
            InvoiceList: [],
            IsActive:"true"
        });
        setIsLoading(false);
    }
    const updateAdjAmount = (TotalAmount) => {
        TotalAmount = TotalAmount.replace(/[^0-9+\s-]/g, "");
        setSaveData({ ...SaveData, TotalAmount });
        if (TotalAmount.trim() === "") {
            AlertBox("error", "Please enter amount greater than 0", "txtTotalAmount");
        }
        else if (Number(TotalAmount.trim()) <= 0) {
            AlertBox("error", "Please enter amount greater than 0", "txtTotalAmount");
        }
        else {
            let numericTotalAmount = Number(TotalAmount);
            let remainingAmount = numericTotalAmount;
            let adjAmount = 0.00;
            let InvoiceList = SaveData.InvoiceList;
            InvoiceList.forEach((item, index) => {
                if (remainingAmount > 0) {
                    if (remainingAmount > item.OutstandingAmount) {
                        adjAmount = item.OutstandingAmount;
                    }
                    else {
                        adjAmount = remainingAmount;
                    }
                    remainingAmount = remainingAmount - adjAmount;
                    InvoiceList[index].ReceivedAmount = adjAmount.toString();
                    InvoiceList[index].IsItemEnable = true;
                }
                else {
                    InvoiceList[index].ReceivedAmount = "0.00";
                    InvoiceList[index].IsItemEnable = false;
                }
            });

            setSaveData(prevSaveData => ({
                ...prevSaveData,
                InvoiceList: InvoiceList
            }));

            setAmountBreakup({
                ...AmountBreakup,
                TotalAmount: numericTotalAmount,
                RemainingAmount: remainingAmount,
                AdjustedAmount: numericTotalAmount - remainingAmount,
            });
        }
    }

    useEffect(() => {
        setFocus('txtCustomer');
        setTitle('PaymentReceipt', setOpen);
        setTimeout(() => {
            setMenuText(document.title);
        }, 500);
    }, [])

    return (
        <main id="main" className="main" style={open ? {} : { marginLeft: "0" }}>
            <section className="section dashboard">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="content-box">
                            <div className="heading-box">
                                <div className="heading">
                                    <h6 className="m-0 font-weight-bold text-primary">{MenuText}</h6>
                                </div>
                            </div>
                            <div className="form-box service-content-area">
                                <div className="row align-items-end">
                                    <div className="col-lg-4 col-md-4 col-sm-12">
                                        <div className="fields">
                                            <AutoCompleteBox
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("txtTotalAmount") };
                                                }}
                                                label='Customer '
                                                placeholder="Customer"
                                                maxLength='50'
                                                options={CustomerArr}
                                                id='txtCustomer'
                                                required={true}
                                                ignore_common={true}
                                                onFocus={() => getCustomer()}
                                                inputValue={SaveData.Customer ? SaveData.Customer : ''}
                                                onInputChange={(event, newInputValue) => {
                                                    HandleChange('Customer', newInputValue);
                                                    if (newInputValue !== '') {
                                                        GetPendingBillData(newInputValue);
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-3 col-md-3 col-sm-6">
                                        <div className="fields">
                                            <DateBox
                                                id='txtInvoiceFromDate'
                                                inputrefs={inputrefs}
                                                disabled={IsBackOfficeUser === "NO"}
                                                label='Payment Receipt Date'
                                                placeholder="Payment Receipt Date"
                                                required={false}
                                                selected={SaveData.ReceiptDate === '' ? '' : new Date(SaveData.ReceiptDate)}
                                                onChange={(e) => {
                                                    let dateArr = e?.toString()?.split(' ')
                                                    dateArr = `${dateArr[2]}-${dateArr[1]}-${dateArr[3]}`
                                                    setSaveData({ ...SaveData, ReceiptDate: dateArr })
                                                }}
                                                maxDate={new Date()}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("txtSalesPerson") };
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-sm-6">
                                        <div className="fields">
                                            <label className="col-12">Advance Amount</label>
                                            <input
                                                className="col-12 "
                                                id='txtAdditionalAMount'
                                                type="text"
                                                maxLength="4"
                                                placeholder={'Advance Amount'}
                                                value={SaveData.AdvanceAmount}
                                                onChange={(e) => {
                                                    setSaveData({ ...SaveData, AdvanceAmount: e.target.value })
                                                }}
                                                //disabled={SaveData.AdvanceAmount && !SaveData.IsActive}
                                            />
                                        </div>
                                    </div>
                                    {/*<div className="col-lg-2 col-md-3 col-sm-6">*/}
                                    {/*    <div className="form-check form-switch">*/}
                                    {/*        <label*/}
                                    {/*            className="form-check-label"*/}
                                    {/*            htmlFor="activeCheckbox"*/}
                                    {/*        >*/}
                                    {/*            Active*/}
                                    {/*        </label>*/}
                                    {/*        <input*/}
                                    {/*            className="form-check-input"*/}
                                    {/*            type="checkbox"*/}
                                    {/*            id="chkActive"*/}
                                    {/*            name='Active'*/}
                                    {/*            onKeyDown={(e) => {*/}
                                    {/*                if (e.key === 'Enter') {*/}
                                    {/*                    setFocus('btnSave')*/}
                                    {/*                };*/}
                                    {/*            }}*/}
                                    {/*            checked={SaveData.IsActive}*/}
                                    {/*            onChange={(e) => {*/}
                                    {/*                setSaveData({*/}
                                    {/*                    ...SaveData, IsActive: e.target.checked*/}
                                    {/*                })*/}
                                    {/*            }}*/}
                                    {/*        />*/}
                                    {/*    </div>*/}
                                    {/*</div>*/}
                                    <div className="col-lg-1 col-md-1"></div>
                                    <div className="col-lg-6 col-md-6 col-sm-12" style={{ display:"none" }}>
                                        <div className="form-box service-content-area1 d-flex" style={{ backgroundColor: "white", borderRadius: "10px" }}>
                                            <h6 className="m-0 font-weight-bold " style={{ color: "black", paddingRight: "15px" }}>Total Amount<br /><b>
                                                {AmountBreakup.TotalAmount.toFixed(2)} </b></h6>
                                            <h6 className="m-0 font-weight-bold " style={{ color: "black", paddingRight: "15px" }}> Paid Amount<br /><b>
                                                {AmountBreakup.AdjustedAmount.toFixed(2)}</b> </h6>
                                            <h6 className="m-0 font-weight-bold " style={{ color: "black", paddingRight: "15px" }}> Balance Amount<br /><b>
                                                {AmountBreakup.RemainingAmount.toFixed(2)} </b></h6>
                                        </div>
                                    </div>
                                    <hr className="mt-4" />
                                    <div className="row">
                                        <div className="col-lg-5 col-md-12 col-sm-12">
                                            <div className="content-box">
                                                <div className="form-box service-content-area payment-form-box">
                                                    <div className="row align-item-end">
                                                        <div className="col-lg-6 col-md-6 col-sm-12">
                                                            <div className="fields">
                                                                <div className="fields">
                                                                    <label className="col-12">Receipt No </label>
                                                                    <input
                                                                        className=" col-12"
                                                                        id='txtReceiptNo'
                                                                        type="text"
                                                                        maxLength="100"
                                                                        placeholder='System-Generated'
                                                                        disabled={true}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-6 col-md-6 col-sm-12">
                                                            <div className="fields">
                                                                <label className="col-12">Total Amount <span style={{ color: "red" }}> *</span></label>
                                                                <input
                                                                    className="col-12"
                                                                    id='txtTotalAmount'
                                                                    type="text"
                                                                    maxLength="10"
                                                                    disabled
                                                                    style={{ minWidth: '70px', textAlign: 'right' }}
                                                                    placeholder='Amount'
                                                                    onKeyDown={(e) => {
                                                                        if (e.key === 'Enter') {
                                                                            setFocus('txtReceiptDate');
                                                                        };
                                                                    }}
                                                                    value={SaveData.TotalAmount}
                                                                    onChange={(e) => {
                                                                        updateAdjAmount(e.target.value.replace(/[^0-9+\s-]/g, ""))
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row align-item-end">
                                                        <div className="col-lg-6 col-md-6 col-sm-12">
                                                            <div className="fields">
                                                                <label className="col-12">Receipt Mode <span style={{ color: "red" }}> *</span></label>
                                                                <select
                                                                    id='ddlReceiptMode'
                                                                    className="col-12"
                                                                    onKeyDown={(e) => {
                                                                        if (e.key === 'Enter') {
                                                                            setFocus('txtReceiptDate')
                                                                        };
                                                                    }}
                                                                    value={SaveData.ReceivedMode}
                                                                    onChange={(e) => setSaveData({ ...SaveData, ReceivedMode: e.target.value })}>
                                                                    <option>--Please Select--</option>
                                                                    <option value="Cash">Cash</option>
                                                                    <option value="Cheque">Cheque</option>
                                                                    <option value="Online">Mobile Money</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-6 col-md-6 col-sm-12">
                                                            <div className="fields">
                                                                <label className="col-12">
                                                                    Received Date
                                                                    <span style={{ color: "red" }}> *</span>
                                                                </label>
                                                                <div className="col-12">
                                                                    <DatePicker selected={ReverseFormatDate(SaveData.ReceiptDate)}
                                                                        className="col-12"
                                                                        id='txtReceiptDate'
                                                                        placeholderText='Receipt Date'
                                                                        dateFormat={'dd-MMM-yyyy'}
                                                                        autoComplete='off'
                                                                        onChange={(date) => {
                                                                            setSaveData({ ...SaveData, ReceiptDate: formatDate(date) })
                                                                        }}
                                                                        onKeyDown={(e) => {
                                                                            if (e.key === 'Enter') {
                                                                                setFocus('txtRefNo')
                                                                            };
                                                                        }}
                                                                        maxDate={new Date()}
                                                                    /></div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="row align-items-end">
                                                        <div className="col-lg-6 col-md-6 col-sm-12">
                                                            <div className="fields">
                                                                <label className="col-12">{SaveData.ReceivedMode === 'Cheque' ? 'Cheque No' : 'Ref No'}  </label>
                                                                <input
                                                                    className="col-12 "
                                                                    id='txtRefNo'
                                                                    type="text"
                                                                    maxLength="100"
                                                                    placeholder={SaveData.ReceivedMode === 'Cheque' ? 'Cheque No' : 'Ref No'}
                                                                    value={SaveData.RefNo}
                                                                    onChange={(e) => {
                                                                        setSaveData({ ...SaveData, RefNo: e.target.value })
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                        {SaveData.ReceivedMode === 'Cheque' ? (
                                                            <div className="col-lg-6 col-md-6 col-sm-12">
                                                                <div className="fields">
                                                                    <label className="col-12">
                                                                        Cheque Date
                                                                        <span style={{ color: "red" }}> *</span>
                                                                    </label>
                                                                    <div className="col-12">
                                                                        <DatePicker
                                                                            selected={ReverseFormatDate(SaveData.ChequeDate)}
                                                                            className="col-12"
                                                                            id='txtChequeDate'
                                                                            placeholderText='Cheque Date'
                                                                            dateFormat={'dd-MMM-yyyy'}
                                                                            autoComplete='off'
                                                                            onChange={(date) => {
                                                                                setSaveData({ ...SaveData, ChequeDate: formatDate(date) })
                                                                            }}
                                                                            onKeyDown={(e) => {
                                                                                if (e.key === 'Enter') {
                                                                                    setFocus('txtRemarks')
                                                                                };
                                                                            }}
                                                                            minDate={new Date()}
                                                                        /></div>
                                                                </div>
                                                            </div>
                                                        ) : (<></>)}
                                                    </div>
                                                    <div class="row align-item-end">
                                                        <div className="col-lg-12 col-md-12 col-sm-12 d-flex">
                                                            <div className="fields ">
                                                                <div className="col-12"> <label style={{ fontWeight: "500" }}>Remarks </label></div>

                                                                <textarea
                                                                    id="txtRemarks"
                                                                    className="col-12"
                                                                    placeholder='Enter Remarks'
                                                                    cols={500}
                                                                    value={SaveData.Remarks}
                                                                    onChange={(e) => {
                                                                        setSaveData({ ...SaveData, Remarks: e.target.value })
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                        <div className="col-lg-7 col-md-12">
                                            {
                                                SaveData.InvoiceList.length > 0 ? (
                                                    <div className="col-lg-12 col-md-12 col-sm-12">
                                                        <div className="op-invoice recoard-bata service-content-area" style={{ padding: '0rem 0rem 0rem 0rem' }}>
                                                            <div className="table-responsive">
                                                                <table className="table table-bordered table-striped">
                                                                    <thead>
                                                                        <tr className='light-bg'>
                                                                            <th></th>
                                                                            <th>Ware House</th>
                                                                            <th>Sales Person</th> 
                                                                            <th>Invoice No</th>
                                                                            <th>Invoice Date</th>
                                                                            <th>Invoice Amount</th>
                                                                            <th>OS Amount</th>
                                                                            <th>Paid Amount</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {SaveData.InvoiceList.map((item, bodyIndex) => (
                                                                            <tr className="TableTrhover" key={`row${bodyIndex}`}>
                                                                                <td>
                                                                                    <div className="form-check form-switch">
                                                                                        <input
                                                                                            id={`chkItemEnable${bodyIndex}`}
                                                                                            className="form-check-input"
                                                                                            type="checkbox"
                                                                                            checked={item.IsItemEnable}
                                                                                            disabled
                                                                                            onChange={(e) => {
                                                                                                const newItemDetails = [...SaveData.InvoiceList];
                                                                                                newItemDetails[bodyIndex].IsItemEnable = e.target.checked;
                                                                                                setSaveData({
                                                                                                    ...SaveData,
                                                                                                    InvoiceList: newItemDetails
                                                                                                });
                                                                                            }}
                                                                                        />
                                                                                    </div>
                                                                                </td>
                                                                                <td>{item.WareHouse}</td>
                                                                                <td>{item.SalesPerson}</td>
                                                                                <td>{item.InvoiceNo}</td>
                                                                                <td>{item.InvoiceDate}</td>
                                                                                <td>{item.InvoiceAmount}</td>
                                                                                <td>{item.OutstandingAmount}</td>
                                                                                
                                                                                
                                                                                <td>
                                                                                    <input
                                                                                        id={`txtAmount${bodyIndex + 1}`}
                                                                                        type="text"
                                                                                        style={{ textAlign: 'right' }}
                                                                                        maxLength="10"
                                                                                        onKeyDown={(e) => {
                                                                                            if (e.key === 'Enter') {
                                                                                                let element = document.getElementById(`txtAmount${bodyIndex + 2}`)
                                                                                                if (element) {
                                                                                                    element.select();
                                                                                                }
                                                                                                else {
                                                                                                    setFocus('ddlReceiptMode');
                                                                                                }
                                                                                            };
                                                                                        }}
                                                                                        className="form-control"
                                                                                        placeholder="Received Amount"
                                                                                        value={item.ReceivedAmount}
                                                                                        onChange={(e) => {
                                                                                            let inputValue = e.target.value.replace(/[^\d\-.]/g, '');
                                                                                            if (parseFloat(inputValue) > parseFloat(item.OutstandingAmount)) {
                                                                                                AlertBox("error", "Received amount should not be more than the Outstanding Amount.", `txtAmount${bodyIndex + 1}`);
                                                                                                inputValue = "0.00"; 
                                                                                            }

                                                                                            inputValue = inputValue.toString(); 
                                                                                            const newInvoiceDetails = [...SaveData.InvoiceList];
                                                                                            newInvoiceDetails[bodyIndex].ReceivedAmount = inputValue;
                                                                                            newInvoiceDetails[bodyIndex].IsItemEnable = false;
                                                                                            const totalAmount = newInvoiceDetails.reduce((sum, currentItem) => {
                                                                                                if (!isNaN(parseFloat(currentItem.ReceivedAmount))) {
                                                                                                    if (parseFloat(currentItem.ReceivedAmount) > 0) {
                                                                                                        newInvoiceDetails[bodyIndex].IsItemEnable = true;
                                                                                                    }
                                                                                                    return sum + parseFloat(currentItem.ReceivedAmount);
                                                                                                } else {
                                                                                                    return sum;
                                                                                                }
                                                                                            }, 0);

                                                                                            setSaveData({
                                                                                                ...SaveData,
                                                                                                TotalAmount: String(totalAmount),
                                                                                                InvoiceList: newInvoiceDetails
                                                                                            });
                                                                                        }}

                                                                                        onFocus={(e) => { e.target.select(); }}
                                                                                    />
                                                                                </td>
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : null
                                            }
                                        </div>
                                    </div>
                                    <div className="col-lg-12 mt-3">
                                        <div className="lms-new-button text-center ">
                                            <button className="button save-btn" onClick={handleSubmitData}>
                                                <i className="bi bi-check-lg" /> Save
                                            </button>
                                          
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {isLoading ? <Loader text='Please wait' size='100px' img_path='./assets/img/giphy.gif' /> : <></>}
            {SessionClear ? <ClearSession /> : <></>}
        </main>
    )
}
export default PaymentReceipt